import React, { useState, useEffect, useRef } from "react";
import "fullpage.js/vendors/scrolloverflow";
import "fullpage.js";
import "fullpage.js/dist/jquery.fullpage.min.css";
import $ from "jquery";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import LazyLoad from "react-lazy-load";

import AOS from "aos";
import "aos/dist/aos.css";

import AniImg from "../components/AniImg";
import AniTitle from "../components/AniTitle";
import Model from "../../Model/page/Model";
import Filter from "../../Filter/page/Filter";
import Concept from "../../Concept/page/Concept";
import Footer from "../../common/Footer";
import ArrowsAnimation from "../components/Arrow";
import { useTranslation } from "react-i18next";
import { useColor } from "../../../util/ColorContext";

const Home = () => {
  const lenis = new Lenis();

  const { t } = useTranslation();

  const { changeColor } = useColor();
  const triggerSectionRef = useRef(null); // 색상 변경을 트리거하는 섹션 참조
  const firstSectionRef = useRef(null); // 첫 번째 섹션 참조

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  $(() => {
    $("#fullpage").fullpage({
      scrollOverflow: true,
      navigationPosition: "left",
      scrollHorizontally: true,
      showActiveTooltip: true,
      scrollingSpeed: 800,
      fitToSection: true,
      fitToSectionDelay: 1200,

      // 화면별 전환
      afterLoad: function (index, anchorLink) {
        AOS.refresh();
        $(".fp-table.active .aos-init").addClass("aos-animate");
      },
    });
  });

  useEffect(() => {
    //init Aos
    AOS.init();
    // Register ScrollTrigger with GSAP
    gsap.registerPlugin(ScrollTrigger);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === triggerSectionRef.current) {
            // 트리거 섹션이 viewport에 들어오면 헤더 색상 변경
            if (entry.isIntersecting) {
              changeColor("#000000"); // 변경할 색상 코드
            }
          } else if (entry.target === firstSectionRef.current) {
            // 첫 번째 섹션이 viewport에 들어오면 원래 색상으로 복원
            if (entry.isIntersecting) {
              changeColor("#FFFFFF"); // 원래 색상 코드
            }
          }
        });
      },
      {
        root: null, // viewport를 root로 설정
        threshold: 0.1, // 10% 요소가 보여질 때 콜백 실행
      }
    );

    // 관찰할 요소 등록
    if (triggerSectionRef.current) {
      observer.observe(triggerSectionRef.current);
    }
    if (firstSectionRef.current) {
      observer.observe(firstSectionRef.current);
    }

    // 컴포넌트 언마운트 시 관찰 중지
    return () => {
      observer.disconnect();
    };
  }, [changeColor]);

  requestAnimationFrame(raf);

  return (
    <div id="fullpage">
      <div className="section">
        <AniTitle />
      </div>
      <div className="section">
        <AniImg url="/assets/images/sample1.svg" text={t("AniImgTitle_1")} />
      </div>
      <div className="section">
        <AniImg url="/assets/images/sample2.svg" text={t("AniImgTitle_2")} />
      </div>
      <div className="section" ref={firstSectionRef}>
        <AniImg url="/assets/images/sample3.svg" text={t("AniImgTitle_3")} />
      </div>
      <div className="section" ref={triggerSectionRef}>
        <AniImg backgroundColor="#fff" color="#000" text={t("AniImgTitle_4")} />
      </div>
      <div className="section">
        <Model />
        <Filter />
        <Concept />
        <Footer />
      </div>
    </div>
  );
};

export default Home;
